
    import Vue from 'vue';
    import MaterialCard from "../views/base/MaterialCard.vue";
    import User from "../models/user";
    import {eventBus} from "@/services/event-bus";
    import utils from "@/services/utils";


    export default Vue.extend({
        name: 'PagesLogin',

        components: {
            baseMaterialCard: MaterialCard
        },

        data() {
            return {
                user: new User('', '', '', '', '', 0),
            }
        },
        computed: {
            loggedIn: () => {
                const auth = utils.isNotNull(localStorage.getItem('state')) ? JSON.parse(String(localStorage.getItem('state'))).auth : null;
                return utils.isNotNull(auth) ? Boolean(auth.status.loggedIn) : false
            }
        },
        created() {
            if (this.loggedIn) {
                this.$router.push('/');
            }
        },
        methods: {
            handleLogin() {
                this.$data.user.office = Number(this.$route.params.office);
                this.$validator.validateAll();

                if (this.$validator.errors.any()) {
                    return;
                }

                if (this.$data.user.username && this.$data.user.password) {
                    this.$store.dispatch('auth/login', this.$data.user).then(
                        () => {
                            this.$router.push('/');
                        },
                        error => {
                            eventBus.$emit('error', error)
                        }
                    );
                }
            }
        },
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        }

    });
